import axios from 'axios'

const apiUrl = window.config.apiUrl

export const getRFIInfantFruitsAndVegsPackage = newProduct => {
  let newRFIInfantFruitsAndVegsPackage = {
    UPC: newProduct.UPC,
    ProductType: newProduct.ProductType,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newRFIInfantFruitsAndVegsPackage.MultiPackageCount =
      newProduct.MultiPackageCount
  }
  return newRFIInfantFruitsAndVegsPackage
}

export const updateRFIInfantFruitsAndVegsPackage = newProduct => {
  let newRFIInfantFruitsAndVegsPackage = {
    UPC: newProduct.UPC,
    ProductType: newProduct.ProductType,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newRFIInfantFruitsAndVegsPackage.MultiPackageCount =
      newProduct.MultiPackageCount
  }
  return newRFIInfantFruitsAndVegsPackage
}

export const getRFIInfantFruitsVegsCategories = async () => {
  try {
    const brandNameOptions = []
    const userToken = JSON.parse(localStorage.getItem('okta-token-storage'))

    await axios
      .get(
        `${apiUrl}/products/brandspecific/rfi/infant/fruitsvegs/categories`,
        {
          headers: {
            Authorization: `Bearer ${userToken?.accessToken?.accessToken}`,
          },
        }
      )
      .then(res => {
        JSON.parse(res.data.result).forEach(brandName => {
          brandNameOptions.push({
            value: brandName,
            label: brandName,
          })
        })
      })
    return brandNameOptions
  } catch (err) {
    console.log('getRFIInfantFruitsVegsCategories error: ', err.response?.msg)
  }
}
